import { Box, Divider, Heading, Text } from "@chakra-ui/react";

type Props = {
  /** Small mono label above the title, e.g. "02 / Flight Heritage". */
  eyebrow: string;
  title: string;
  description?: string;
};

// Single source of truth for section typography so every section aligns.
export default function SectionHeader({ eyebrow, title, description }: Props) {
  return (
    <Box mb={{ base: 10, md: 14 }}>
      <Text
        fontFamily="mono"
        fontSize="xs"
        letterSpacing="0.2em"
        textTransform="uppercase"
        color="whiteAlpha.500"
        mb={4}
      >
        {eyebrow}
      </Text>
      <Heading
        fontSize={{ base: "3xl", md: "4xl" }}
        fontWeight="500"
        letterSpacing="-0.03em"
        color="white"
      >
        {title}
      </Heading>
      {description && (
        <Text mt={4} color="whiteAlpha.600" fontSize="md" maxW="2xl" lineHeight="1.7">
          {description}
        </Text>
      )}
      <Divider mt={{ base: 8, md: 10 }} borderColor="whiteAlpha.200" />
    </Box>
  );
}
